function bindKey( win, mac ) {
    return {
        win,
        mac,
    };
}

export default bindKey;
